export default {
  BuTranfer: 34, // Chuyển khoản kho bạc
  // Bawithdraw: 33, // Chi tiền gửi
  // CashPayment: 21, // Chi tiền mặt
  // BUTreasuryWithdrawal: 31, //Phiếu rút tiền kho bạc
  // Butransferdeposit: 165, // Chuyển khoản kho bạc vào tiền gửi
};
